import { VMarkdownView } from 'vue3-markdown'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.component('VMarkdownView', VMarkdownView)
})
